<template>
    <AppCard>
        <div class="flex flex-col h-full">
            <div class="h-16 mb-2">
                <img v-if="manufacturer.image" :data-src="manufacturer.image" class="h-full mx-auto lazy">
            </div>

            <img v-if="modelImage" :data-src="modelImage" class="max-h-24 mx-auto lazy">

            <div v-else class="text-center">
                <FontAwesomeIcon :icon="['fat', 'car-side']" size="6x"></FontAwesomeIcon>
            </div>

            <h3 class="text-black font-bold mb-4 text-lg">{{ manufacturer.name }}</h3>

            <p class="mb-3">Popular models:</p>

            <ul class="p-0 mb-4">
                <li class="underline" v-for="model of models">
                    <InertiaLink :href="route('manufacturers.models.show', [manufacturer, model])">
                        {{ model.name }}
                    </InertiaLink>
                </li>
            </ul>

            <AppButton :href="route('manufacturers.show', manufacturer)" class="mb-3 w-full mt-auto">
                View more
            </AppButton>

            <p class="text-center" v-if="reviewsCount">{{ reviewsCount }} tyre reviews</p>
        </div>
    </AppCard>
</template>

<script>
import AppCard from "@/Components/AppCard";
import AppButton from "@/Components/AppButton";
import {InertiaLink} from "@inertiajs/inertia-vue3";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import LazyLoad from "vanilla-lazyload";

export default {
    components: {AppButton, AppCard, InertiaLink, FontAwesomeIcon, LazyLoad},
    props: {
        manufacturer: Object
    },
    mounted() {
        let lazyLoadInstance = new LazyLoad({});
    },
    computed: {
        models() {
            return this.manufacturer.models;
        },
        reviewsCount() {
            return this.manufacturer.reviews_count?.toLocaleString();
        },
        modelImage() {
            if (this.models.length === 0) return null;

            const firstModel = this.models[0];

            return firstModel.image;
        }
    },
};
</script>

<style scoped>

</style>
